import { isStreamIQ, isToya } from '@/shared/lib'

export const getEPGRepository = async () => {
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/features/repositories/useEPGToyaRepository')

            return module.useEPGToyaRepository
        } catch (error) {
            console.warn(
                'useEPGToyaRepository module is missing. TOYA-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/features/repositories/useEPGStreamIQRepository')

            return module.useEPGStreamIQRepository
        } catch (error) {
            console.warn(
                'useEPGToyaRepository module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
